import { render, staticRenderFns } from "./TabsField.vue?vue&type=template&id=37597ddb"
import script from "./TabsField.vue?vue&type=script&lang=js"
export * from "./TabsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports